import { Pressable } from "react-native";

import { Alert, Col, Row, Surface, TextBody } from "../lib";
import { BookingDetails } from "./booking-details";
import { BookingItemUser } from "./booking-item-user";
import { Booking, User } from "../services";
import { createStyles, sizes } from "../theme";
import { JSX, useCallback } from "react";

export type BookingItemProps = {
  actions?: JSX.Element;
  booking: Booking;
  timer?: JSX.Element;
  isUserPremium?: boolean;
  goToPremium: () => void;
  onShow: (id: number) => void;
  user: User;
};

export function BookingItem({
  actions,
  booking,
  goToPremium,
  onShow,
  timer,
  user,
}: BookingItemProps) {
  // Handlers
  const handleShow = useCallback(() => {
    onShow?.(booking.id);
  }, [onShow, booking.id]);

  // Render
  return (
    <Pressable onPress={handleShow}>
      <Surface m="4" style={$.container}>
        <Row.LR>
          <TextBody em>{booking.customer_name}</TextBody>
          {!!timer && timer}
        </Row.LR>

        <Col>
          {user.premium ? (
            <BookingItemUser
              {...{
                score: booking.user.score,
                quality: booking.user.quality,
                premium: booking.user.premium,
              }}
            />
          ) : (
            <Alert
              icon="star-circle"
              message="Buy Premium to see customer quality & score"
              onPress={goToPremium}
              small
              variant="warning"
            />
          )}
        </Col>

        <Col>
          <BookingDetails
            {...{
              date: new Date(booking.date),
              placeId: booking.location.place_id,
              locationName: booking.location.name,
              duration: booking.duration,
              total: booking.total_formatted,
              incall: booking.incall,
              timeZone: booking.city.timezone,
            }}
          />
        </Col>

        <Col>{actions}</Col>
      </Surface>
    </Pressable>
  );
}

const $ = createStyles({
  container: {
    marginBottom: 0,
    elevation: 5,
    gap: sizes["4"],
  },
});
